import { IconWrapper } from './IconWrapper'
import { IIconProps } from './props'

export function ChevronRightIcon(props: IIconProps) {
  return (
    <IconWrapper {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.60156 2.8002L10.4016 8.0002L5.60156 13.2002"
          stroke="#01425F"
          strokeWidth="1.2375"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconWrapper>
  )
}
